import axios from 'axios';

export const getMerchandiseOrderList = (
  status: number,
  construct_sub: string,
  user_id: number,
  product_name: string,
  specification: string,
  construct_num: string,
  customer_name: string,
  partner: string,
  delivery_from_date: string,
  delivery_end_date: string,
  order_from_date: string,
  order_end_date: string,
  payment_from_date: string,
  payment_end_date: string,
  prefecture_name: string,
  address: string,
  current_page: number,
  display_limit: number,
  billing_total_start: number | null,
  billing_total_end: number | null,
  sort_direction: string | null,
  sort_field: string | null
) => {
  return axios
    .get(`/api/v1/merchandise/orders`, {
      params: {
        status,
        construct_sub,
        user_id,
        product_name,
        specification,
        construct_num,
        customer_name,
        partner,
        delivery_from_date,
        delivery_end_date,
        order_from_date,
        order_end_date,
        payment_from_date,
        payment_end_date,
        prefecture_name,
        address,
        page: current_page,
        display_limit,
        sort_direction,
        sort_field,
        billing_total_start,
        billing_total_end
      },
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteMerchandiseOrderList = (products_list: any) => {
  return axios
    .post(
      `/api/v1/delete/merchandise/orders`,
      {
        products_list: products_list
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const deleteSingleMerchandiseOrder = (id: number) => {
  return axios
    .delete(`/api/v1/merchandise/orders/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getDeliverySites = () => {
  return axios
    .get(`/api/v1/get/delivery/sites`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const createMerchandiseOrder = (
  id: number,
  user_id: number,
  partner_id: number,
  honorific_title: string,
  delivery_site_id: number,
  order_date: string,
  order_status: number,
  payment_date: string,
  delivery_date: string,
  sample1_user_id: number,
  sample2_user_id: number,
  remarks: string,
  billing_note: string,
  memo: string,
  items: any
) => {
  return axios
    .post(
      `/api/v1/merchandise/orders/${id}`,
      {
        user_id,
        partner_id,
        honorific_title,
        delivery_site_id,
        order_date,
        order_status,
        payment_date,
        delivery_date,
        sample1_user_id,
        sample2_user_id,
        remarks,
        billing_note,
        memo,
        items
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getMerchandiseOrderDetails = (id: number) => {
  return axios
    .get(`/api/v1/merchandise/orders/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// // TODO: MEMOを消す
// // MEMO: /api/v1/merchandise/orders/{product_id}のputメソッドの中にメール送信処理が内包されている。
export const updateMerchandiseOrder2 = (
  id: number,
  user_id: number,
  partner_id: number,
  honorific_title: string,
  delivery_site_id: number,
  order_date: string,
  order_status: number,
  delivery_date: string,
  payment_date: string,
  remarks: string,
  billing_note: string,
  memo: string,
  items: any
  // invoice_billing_total?: number,
) => {
  return axios
    .put(
      `/api/v1/merchandise/orders/${id}`,
      {
        user_id,
        partner_id,
        honorific_title,
        delivery_site_id,
        order_date,
        order_status,
        delivery_date,
        payment_date,
        remarks,
        billing_note,
        memo,
        items
        // invoice_billing_total,
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateMerchandiseOrder = (
  id: number,
  user_id: number,
  partner_id: number,
  honorific_title: string,
  delivery_site_id: number,
  order_date: string,
  order_status: number,
  delivery_date: string,
  payment_date: string,
  sample1_user_id: number,
  sample2_user_id: number,
  remarks: string,
  billing_note: string,
  memo: string,
  items: any,
  invoice_billing_total: number | undefined
) => {
  return axios
    .put(
      `/api/v1/merchandise/orders/${id}`,
      {
        user_id,
        partner_id,
        honorific_title,
        delivery_site_id,
        order_date,
        order_status,
        delivery_date,
        payment_date,
        sample1_user_id,
        sample2_user_id,
        remarks,
        billing_note,
        memo,
        items,
        invoice_billing_total
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateMerchandiseOrderInvoiceTotal = (
  product_id: number,
  invoice_billing_total: number
) => {
  return axios
    .put(
      `/api/v1/merchandise/orders/${product_id}/partial-update`,
      {
        invoice_billing_total
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const copyMerchandise = (product_id: number, construct_id: number) => {
  return axios
    .post(
      `/api/v1/copy/merchandise/orders/${product_id}`,
      { construct_id },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateStatus = (product_id: number, status: number) => {
  return axios
    .post(`/api/v1/update/status/${product_id}?status=${status}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

// TODO: 関数名変える。暫定処理として現在は命名
export const updateMerchandiseStatus = (
  product_id: number,
  order_status: number
) => {
  return axios
    .put(
      `/api/v1/merchandise/orders/${product_id}/partial-update`,
      {
        order_status
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateMerchandiseInvoiceBillingTotal = (
  product_id: number,
  invoice_billing_total: number
) => {
  return axios
    .put(
      `/api/v1/merchandise/orders/${product_id}/partial-update`,
      {
        invoice_billing_total
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getExportMerchandiseItems = (
  selected_columns: any,
  status: number,
  construct_sub: string,
  user_id: number,
  product_name: string,
  specification: string,
  customer_name: string,
  partner: string,
  delivery_from_date: string,
  delivery_end_date: string,
  order_from_date: string,
  order_end_date: string,
  payment_from_date: string,
  payment_end_date: string,
  prefecture_name: string,
  address: string
) => {
  return axios
    .post(
      `/api/v1/export/merchandise/list?status=${status}&construct_sub=${construct_sub}&user_id=${user_id}&product_name=${product_name}&specification=${specification}&customer_name=${customer_name}&partner=${partner}&delivery_from_date=${delivery_from_date}&delivery_end_date=${delivery_end_date}&order_from_date=${order_from_date}&order_end_date=${order_end_date}&payment_from_date=${payment_from_date}&payment_end_date=${payment_end_date}&prefecture_name=${prefecture_name}&address=${address}`,
      {
        selected_columns
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const updateProductPurchaseMemo = (product_id: number, memo: string) => {
  return axios
    .put(
      `/api/v1/merchandise/orders/${product_id}/memo`,
      {
        memo
      },
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
